import React, { useState, useEffect /*, useRef*/ } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faSearch/*, faFilter*/ } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import Highlighter from 'react-highlight-words';

import history from '../history';
import '../assets/css/FormSearch.scss';

//Redux
import {getParams} from '../store/params/reducer';
import updateParams from '../store/params/action';
import {connect} from 'react-redux';

const FormSearch = ({
  classForm,
  rowClass,
  itemsView,
  search,
  setSearch,
  loc,
  setLoc,
  responsiveMenu,
  show,
  setShow,
  params,
  updateParams
}) => {

  const location = useLocation();
  const [directions, setDirections] = useState([]);
  const [searchIsFocused, setSearchIsFocused] = useState(false);
  const [locationIsFocused, setLocationIsFocused] = useState(false);
  const [selectedSearch, setSelectedSearch] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(false);
  const [errors, setErrors] = useState({
    query: false,
    location: false,
  });

  const getData = () => {
    let url = `${process.env.REACT_APP_API_PREFIX}/regionesycomunas`;
    axios
      .get(url, {
        headers: {
          'Content-type': 'application/json',
          Accept: '*/*',
        },
      })
      .then(function (response) {
        let regions = response.data;
        let array = [];
        regions.forEach((region) => {
          let obj = {
            label: region.region,
            value: region.region_number,
            isComune: false,
          };
          array.push(obj);
          region.provincias.forEach((provincia) => {
            provincia.comunas.forEach((comuna) => {
              array.push({
                ...obj,
                label: [comuna.name, provincia.name, region.region].join(', '),
                value: comuna.name,
                isComune: true,
              });
            });
          });
        });
        setDirections(array);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getUrlParams = (data) => {
    let urlParams = '?query=' + data.query;

    let hasLocation = false;
    if (
      typeof data.region !== 'undefined' &&
      data.region !== null &&
      data.region !== ''
    ) {
      hasLocation = true;
      data.region && (urlParams += '&region=' + data.region);
    }
    if (
      typeof data.comune !== 'undefined' &&
      data.comune !== null &&
      data.comune !== ''
    ) {
      hasLocation = true;
      data.comune && (urlParams += '&comune=' + data.comune);
    }
    if (hasLocation) {
      if (
        typeof data.defaultLocation !== 'undefined' &&
        data.defaultLocation !== null &&
        data.defaultLocation !== ''
      ) {
        let regionLabel = JSON.parse(data.defaultLocation).label;
        let type = JSON.parse(search.defaultLocation).name;
        urlParams += '&label=' + regionLabel + '&type=' + type;
      }
    }

    return urlParams;
  }

  const submitForm = (e) => {
    e.preventDefault();
    if (validation()) {

      let urlParams = getUrlParams(search);
      let location = '';
      let locationType = '';
      let locationValue = '';
      let locationTxt = '';

      if (
        typeof search.defaultLocation !== 'undefined' &&
        search.defaultLocation !== null &&
        search.defaultLocation !== ''
      ) {
        location = JSON.parse(search.defaultLocation);
        locationType = location.name ? location.name : '';
        locationValue = location.value ? location.value : '';
        locationTxt = location.label ? location.label : '';
      }

      updateParams({
        ...params,
        location,
        locationType,
        locationValue,
        locationTxt,
        search: search.query,
        limit:18,
        from:0,
      });

      history.push({
        pathname: '/search',
        search: urlParams,
      });
    }
  };

  const validation = () => {
    setErrors({});
    let control = false;
    let errorsObj = {};
    let obj = {
      query: search.query,
      region: typeof search.region !== "undefined" ? search.region : '',
      comune: typeof search.comune !== "undefined" ? search.comune : ''
    };
    for (var key in obj) {
      if(obj[key]!==""){
        control = true;
        errorsObj.[key] = false;
      } else {
        errorsObj.[key] = true;
      }
    }
    if(!control){
      setErrors({
        query: errorsObj.query,
        location:(errorsObj.comune && errorsObj.region ? true : false)
      });
    }
    return control;
  };

  const handleChange = (e) => {
    resetErrorsValidation(e);
    if (e && e.target) {
      let obj = {
        ...search,
        [e.target.name]: e.target.value,
      };
      if (typeof e.target.label !== 'undefined' && e.target.label !== '') {
        obj.defaultLocation = JSON.stringify(e.target);
      }
      setSearch(obj);
    }
  };

  const resetErrorsValidation = (e) => {
    if (e && e.target && e.target.value.length > 1) {
      setErrors({
        ...errors,
        [e.target.name.replace(/comune|region/gi, 'location')]: false,
      });
    }
  };

  const formatOptionLabel = ({ label }, { inputValue }) => {
    return (
      <Highlighter
        searchWords={[inputValue]}
        textToHighlight={label}
        highlightClassName="highlighter-component"
      />
    );
  };

  useEffect(getData, []);

  return (
      <div className={'row ' + rowClass}>

      {
        (responsiveMenu && show) || !responsiveMenu ?
          <form
            className={
              classForm + ' ' + (itemsView !== 'grid' ? '' : 'border-colored')
            }
            onSubmit={(e) => submitForm(e)}
          >
            <div className="form-row pt-5">
              <div className="form-group col-sm col-md-6">
                <label htmlFor="query">¿Qué estás buscando?</label>
                <div className="input-group input-group-lg mb-2">
                  <div className="input-group-prepend">
                    <div
                      className={
                        'search-input input-group-text input-search ' +
                        (selectedSearch ? 'search-select-icon' : '')
                      }
                    >
                      <FontAwesomeIcon icon={faSearch} />
                    </div>
                  </div>
                  <input
                    type="text"
                    className={
                      'search-input form-control input-search' +
                      (selectedSearch ? 'search-select' : '')
                    }
                    placeholder={searchIsFocused ? '' : 'Escribe aquí lo que buscas'}
                    name="query"
                    id="query"
                    autoComplete="off"
                    onChange={handleChange}
                    value={search.query}
                    onFocus={() => {
                      setSelectedSearch(true);
                      setSearchIsFocused(true);
                    }}
                    onBlur={() => {
                      setSelectedSearch(false);
                      setSearchIsFocused(false);
                    }}
                  />
                </div>
                {errors.query ? (
                  <span className="text-danger text-small d-block mb-2">
                    Debe ingresar algún criterio de búsqueda
                  </span>
                ) : null}
              </div>
              <div className="form-group col-sm col-md-4">
                <label htmlFor="location">¿Dónde quieres buscar?</label>
                <div className="input-group input-group-lg mb-2">
                  <div className="input-group-prepend">
                    <div
                      className={
                        'input-group-text input-search ' +
                        (selectedLocation ? 'search-select-icon' : '')
                      }
                    >
                      <FontAwesomeIcon icon={faMapMarkerAlt} />
                    </div>
                  </div>

                  <Select
                    options={directions}
                    className={
                      'form-control react-select-component ' +
                      (selectedLocation ? 'search-select' : '')
                    }
                    placeholder={locationIsFocused ? '' : 'Ejemplo: La Serena'}
                    isClearable={true}
                    isLoading={!directions}
                    loadingMessage={() => 'Cargando...'}
                    classNamePrefix="rs"
                    value={loc}
                    formatOptionLabel={formatOptionLabel}
                    onFocus={() => {
                      setSelectedLocation(true);
                      setLocationIsFocused(true);
                    }}
                    onBlur={(e) => {
                      setSelectedLocation(false);
                      setLocationIsFocused(false);
                    }}
                    onChange={(_item) => {
                      setLoc(_item);
                      const item = search;
                      item.region = '';
                      item.comune = '';
                      item.defaultLocation = '';
                      setSearch({ ...search, ...item });
                      _item &&
                        handleChange({
                          target: {
                            name: _item.isComune ? 'comune' : 'region',
                            value: _item.value,
                            label: _item.label,
                          },
                        });
                    }}
                  />
                </div>

                {errors.location ? (
                  <span className="text-danger text-small d-block mb-2">
                    Debe ingresar algún criterio de búsqueda
                  </span>
                ) : null}
              </div>
              <div className="form-group col-sm col-md-2 btn-m-t-31">
                <input
                  type="submit"
                  className={
                    'btn btn-block btn-search btn-lg ' +
                    (location.pathname === '/' ? 'px-5' : 'px-3')
                  }
                  value="Buscar"
                />
              </div>
            </div>
          </form>
        :
        null
      }
      </div>
  );
};

const mapStateToProps = state => {
  return {
    params: getParams(state)
  };
};

export default connect(mapStateToProps, {updateParams})(FormSearch);
